export default function VisualCards() {
  const cards = [
    {
      img: 'https://readdy.ai/api/search-image?query=Modern%20minimal%20workspace%20desk%20with%20open%20laptop%20displaying%20colorful%20charts%20on%20screen%2C%20notebook%20and%20coffee%20cup%2C%20warm%20cream%20background%2C%20soft%20morning%20light%20streaming%20through%20window%2C%20editorial%20productivity%20lifestyle%20photography%2C%20clean%20organized%20composition&width=800&height=800&seq=visual-s1-litbuy-v2&orientation=squarish',
      alt: 'Litbuy Spreadsheet workspace setup',
      title: 'Smart Automation',
    },
    {
      img: 'https://readdy.ai/api/search-image?query=Elegant%20data%20dashboard%20displayed%20on%20tablet%20next%20to%20analytics%20printouts%2C%20warm%20beige%20desk%20surface%2C%20soft%20natural%20lighting%20from%20side%2C%20modern%20business%20analytics%20concept%2C%20minimalist%20still%20life%2C%20professional%20editorial%20quality&width=800&height=800&seq=visual-s2-litbuy-v2&orientation=squarish',
      alt: 'Litbuy Spreadsheet real-time tracking',
      title: 'Real-Time Tracking',
    },
    {
      img: 'https://readdy.ai/api/search-image?query=Creative%20flat%20lay%20with%20designer%20stationery%20and%20spreadsheet%20templates%20printed%20on%20paper%2C%20minimal%20cream%20desk%20surface%2C%20warm%20diffused%20lighting%2C%20artistic%20organized%20composition%2C%20modern%20productivity%20tools%2C%20editorial%20photography&width=800&height=800&seq=visual-s3-litbuy-v2&orientation=squarish',
      alt: 'Litbuy Spreadsheet ready templates',
      title: 'Ready Templates',
    },
  ];

  return (
    <section className="relative bg-background-100 py-20 md:py-28 overflow-hidden">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-14">
          <p className="text-xs tracking-widest uppercase text-accent-600 font-medium">Why Choose Litbuy</p>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mt-3">
            Built for Efficiency
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            Litbuy Spreadsheet combines powerful automation with an intuitive design — making data management simpler than ever.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-8 relative">
          {cards.map((card, index) => (
            <div
              key={index}
              className={`relative rounded-xl overflow-hidden bg-background-50 w-full max-w-xs md:max-w-sm ${
                index === 1 ? 'md:-mt-6 md:z-10' : 'md:mt-4'
              }`}
              style={{
                transform: index === 1 ? 'scale(1.05)' : index === 0 ? 'rotate(-1deg)' : 'rotate(1deg)',
              }}
            >
              <div className="w-full h-64 md:h-72 overflow-hidden">
                <img
                  src={card.img}
                  alt={card.alt}
                  className="w-full h-full object-cover object-top transition-transform duration-500 hover:scale-105"
                  title={card.title}
                />
              </div>
              <div className="p-5 text-center">
                <p className="text-sm font-medium text-foreground-900">{card.title}</p>
                <p className="text-xs text-foreground-500 mt-1">Discover how Litbuy Spreadsheet transforms your workflow</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}